export const TYPE_BANNER = 1
export const TYPE_POPUP = 2

export const types = {
  'banner': TYPE_BANNER,
  'popup': TYPE_POPUP
}
